import { render, staticRenderFns } from "./RecuperaPswd.vue?vue&type=template&id=733729d5"
import script from "./RecuperaPswd.vue?vue&type=script&lang=js"
export * from "./RecuperaPswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports